module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "blockquote1"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm07_pre2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('em', [_vm._v("But I dwell now well in the making of the future. Little by little, time is kneading me into shape. A child is not frightened at the thought of being patiently turned into an old man. I too play my games. I count the dials, the levers, the buttons, the knobs of my kingdom.")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ANTOINE DE SAINT-EXUPÉRY")]), _vm._v(", "), _c('em', [_vm._v("Flight to Arras")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ae2229","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm07_pre2.vue
// module id = 81
// module chunks = 0